import React from 'react'
import Carousel from 'react-material-ui-carousel'
import dragon from "./../../images/dragon_1.jpg"
import osiris from "./../../images/osiris.jpg"
import tiberia from "./../../images/tiberia.jpg"
import timetravel from "./../../images/timetravel.jpg"
import {Link} from 'react-router-dom';


//import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
//import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';


export const MiniCarousel = (props) => {
  var items = [
    {
        src: dragon,
        txt: "dragon"
    },
    {
        src: osiris,
        txt: "osiris"
    },
    {
        src: tiberia,
        txt: "tiberia"
    },
    {
        src: timetravel,
        txt: "timetravel"
    },
  ]
  return (
    <>
        <Carousel navButtonsAlwaysVisible={true} indicators={false}>
            {
                items.map( (item, i) => <Item key={i} item={item} /> )
            }
        </Carousel>
      
    </>
  )
}
function Item(props)
{
    return(
      <img src={props.item.src} alt={props.item.txt} style={{width:"100%", display:"block"}}/>
    )
}